module.exports = {"361021100":"建昌镇","361021101":"株良镇","361021102":"上唐镇","361021103":"里塔镇","361021104":"洪门镇","361021105":"沙洲镇","361021106":"龙湖镇","361021107":"新丰街镇","361021108":"万坊镇","361021109":"徐家镇","361021201":"天井源乡","361021203":"浔溪乡","361021400":"南城县工业园区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/361021.json
// module id = 1228
// module chunks = 0